<template>
    <app-modal-new
        name="modal-onboarding-meeting"
        title="PREONBOARDING.MODALS.ONBOARDING_MEETING.TITLE"
        width="lg"
        :adaptive="false"
        :hide-actions="true"
        @on-show="loadScript"
    >
        <template #content>
            <p class="modal-onboarding-meeting__description">
                {{ $t('PREONBOARDING.MODALS.ONBOARDING_MEETING.BODY') }}
            </p>

            <div class="hs_calendar modal-onboarding-meeting__calendar">
                <!-- Start of Calendly inline widget -->
                <div
                    class="calendly-inline-widget"
                    data-url="https://calendly.com/ahmed-eleryan/30min"
                    style="min-width: 320px; height: 670px;"
                ></div>
                <!-- End of Calendly inline widget -->
            </div>
        </template>
    </app-modal-new>
</template>

<script>
export default {
    methods: {
        loadScript () {
            const scriptTag = document.createElement('script')
            scriptTag.setAttribute('type', 'text/javascript')
            scriptTag.setAttribute('id', 'calendly-widget')
            scriptTag.setAttribute(
                'src',
                'https://assets.calendly.com/assets/external/widget.js'
            )

            document.querySelector('.hs_calendar').appendChild(scriptTag)

            this.$mixpanel.track('Onboarding meeting popup shown')
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@style/sfc.scss';

.modal-onboarding-meeting {
    &__description {
        margin: 0 0 rem(24);
    }

    &__calendar {
        height: rem(670);
    }
}
</style>
